import { useUI } from '@/providers/UIProvider';
import SaveBar from '@/components/SaveBar';
import MediaPreviewModal from '@/components/MediaPreviewModal';
import { useCallback, useMemo } from 'react';

export default function PageComponents() {
  const { saveBar, mediaAsset, setMediaAsset, studioVideo, setStudioVideo } = useUI();

  const handleClosePreview = useCallback(() => {
    setMediaAsset(null);
    setStudioVideo(null);
  }, [setMediaAsset, setStudioVideo]);

  const mediaAssets = useMemo(() => {
    return mediaAsset ? [mediaAsset] : [];
  }, [mediaAsset]);
  return (
    <>
      {saveBar ? (
        <SaveBar
          open={saveBar.open}
          onSave={saveBar.onSave}
          onDiscard={saveBar.onDiscard}
          isDirty={saveBar.isDirty}
          isSaving={saveBar.isSaving}
        />
      ) : (
        // we explicitly need this case to avoid the save bar to be rendered when it's not needed
        <SaveBar open={false} onSave={() => {}} onDiscard={() => {}} isDirty={false} isSaving={false} />
      )}
      <MediaPreviewModal
        isModalOpen={!!mediaAsset}
        closeModal={handleClosePreview}
        mediaAssets={mediaAssets}
        activeAssetId={mediaAsset?.id}
        studioVideo={studioVideo}
      />
    </>
  );
}
